import React from "react";
import { useAuth } from "../../../../core//contexts/AuthContext";

const UserDetail = () => {
  const { authTokens } = useAuth();

  return (
    <ul className="navbar-nav">
      <li className="nav-item btn-rotate dropdown">
        <p>
          <span className=" d-md-block">
            <i className="nc-icon nc-circle-10  mr-2"></i>
            {authTokens.user_name}
          </span>
        </p>

      </li>
    </ul>
  );
};

export default UserDetail;
